import { NAME } from './constants';
import { router } from './router';

export const WmsFinalInspection = {
	name: NAME,
	router,
};
